var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "factoid-wrapper",
    style: {
      backgroundColor: _vm.backgroundColor
    }
  }, [_c('div', {
    staticClass: "promo-factoid"
  }, [_c('div', {
    staticClass: "promo-factoid__bg promo-factoid__bg_desktop"
  }, [_vm.backgroundDesktop ? [_vm.backgroundDesktop.includes('.mp4') || _vm.backgroundDesktop.includes('.webm') ? _c('video', {
    staticClass: "promo-factoid__bg_video",
    attrs: {
      "src": _vm.backgroundDesktop,
      "loop": "",
      "muted": "",
      "autoplay": ""
    },
    domProps: {
      "muted": true
    }
  }) : _c('img', {
    staticClass: "promo-factoid__bg_img",
    attrs: {
      "src": _vm.backgroundDesktop
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "promo-factoid__bg promo-factoid__bg_mobile"
  }, [_vm.backgroundMobile ? [_vm.backgroundMobile.includes('.mp4') || _vm.backgroundMobile.includes('.webm') ? _c('video', {
    staticClass: "promo-factoid__bg_video",
    attrs: {
      "src": _vm.backgroundMobile,
      "loop": "",
      "muted": "",
      "autoplay": ""
    },
    domProps: {
      "muted": true
    }
  }) : _c('img', {
    staticClass: "promo-factoid__bg_img",
    attrs: {
      "src": _vm.backgroundMobile
    }
  })] : _vm._e()], 2), _vm._v(" "), _vm.timerDate ? _c('GGTimerBlock', {
    staticClass: "promo-factoid__timer",
    attrs: {
      "size": _vm.timerSize,
      "color": _vm.timerColor,
      "time": _vm.timerDate
    }
  }) : _vm._e(), _vm._v(" "), _vm.buttonType === 'link' && _vm.link && _vm.linkText ? _c('GGLink', {
    staticClass: "promo-factoid__link",
    attrs: {
      "to": _vm.link
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.linkText))])]) : _vm.buttonType === 'promocode' && _vm.promocode ? _c('GGPromoButton', {
    staticClass: "promo-factoid__button",
    attrs: {
      "text": _vm.promocode,
      "color": _vm.promoButtonColor
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }